import Keycloak from "keycloak-js";
import {useAuthStatusStore} from "stores/useAuthentificationStatusStore";

/**
 * Logs the current user out
 * @param keycloakPromise the promise for keycloak
 */
export async function logout(
  keycloakPromise: Promise<Keycloak>,
): Promise<void> {
  sessionStorage.setItem("userId", "")
  const authStatusStore = useAuthStatusStore();
  authStatusStore.activeAuthStatus = false;
  const keycloak = await keycloakPromise;
  const redirectUri = import.meta.env.VITE_KEYCLOAK_BASE_URL ? keycloak.createLoginUrl() : window.location.origin + keycloak.createLoginUrl();
  await keycloak.logout({ redirectUri });
}

/**
 * Redirects to the register page
 * @param keycloakPromise the promise for keycloak
 */
export async function register(
    keycloakPromise: Promise<Keycloak>,
): Promise<void> {
  const keycloak = await keycloakPromise;
  await keycloak.register();
}

/**
 * Performs a Keycloak login and redirects to the specified page.
 * @param keycloakPromise - A promise that resolves to a Keycloak instance.
 * @param redirect - Optional path to redirect to after login (default: "/tournaments").
 * @returns A promise that resolves when the login process has been triggered.
 */
export async function login(
  keycloakPromise: Promise<Keycloak>,
  redirect = "/tournaments",
): Promise<void> {
  const keycloak = await keycloakPromise;
  const redirectUri = window.location.origin + redirect;
  await keycloak.login( {redirectUri} );
}
